export interface TimezoneOption {
  value: string;
  label: string;
  region: string;
}

export const TIMEZONES: TimezoneOption[] = [
  // América
  { value: 'America/Mexico_City', label: 'Ciudad de México (CST/CDT)', region: 'América' },
  { value: 'America/Monterrey', label: 'Monterrey (CST/CDT)', region: 'América' },
  { value: 'America/Tijuana', label: 'Tijuana (PST/PDT)', region: 'América' },
  { value: 'America/Hermosillo', label: 'Hermosillo (MST)', region: 'América' },
  { value: 'America/Cancun', label: 'Cancún (EST)', region: 'América' },
  { value: 'America/Chihuahua', label: 'Chihuahua (MST/MDT)', region: 'América' },
  { value: 'America/Mazatlan', label: 'Mazatlán (MST/MDT)', region: 'América' },
  { value: 'America/New_York', label: 'Nueva York (EST/EDT)', region: 'América' },
  { value: 'America/Chicago', label: 'Chicago (CST/CDT)', region: 'América' },
  { value: 'America/Denver', label: 'Denver (MST/MDT)', region: 'América' },
  { value: 'America/Los_Angeles', label: 'Los Ángeles (PST/PDT)', region: 'América' },
  { value: 'America/Phoenix', label: 'Phoenix (MST)', region: 'América' },
  { value: 'America/Anchorage', label: 'Anchorage (AKST/AKDT)', region: 'América' },
  { value: 'Pacific/Honolulu', label: 'Honolulu (HST)', region: 'América' },
  { value: 'America/Bogota', label: 'Bogotá (COT)', region: 'América' },
  { value: 'America/Lima', label: 'Lima (PET)', region: 'América' },
  { value: 'America/Santiago', label: 'Santiago (CLT/CLST)', region: 'América' },
  { value: 'America/Caracas', label: 'Caracas (VET)', region: 'América' },
  { value: 'America/Sao_Paulo', label: 'São Paulo (BRT/BRST)', region: 'América' },
  { value: 'America/Buenos_Aires', label: 'Buenos Aires (ART)', region: 'América' },
  { value: 'America/Montevideo', label: 'Montevideo (UYT)', region: 'América' },
  { value: 'America/Asuncion', label: 'Asunción (PYT/PYST)', region: 'América' },
  { value: 'America/La_Paz', label: 'La Paz (BOT)', region: 'América' },
  { value: 'America/Guayaquil', label: 'Guayaquil (ECT)', region: 'América' },
  { value: 'America/Panama', label: 'Panamá (EST)', region: 'América' },
  { value: 'America/Costa_Rica', label: 'Costa Rica (CST)', region: 'América' },
  { value: 'America/Guatemala', label: 'Guatemala (CST)', region: 'América' },
  { value: 'America/Managua', label: 'Managua (CST)', region: 'América' },
  { value: 'America/Tegucigalpa', label: 'Tegucigalpa (CST)', region: 'América' },
  { value: 'America/El_Salvador', label: 'El Salvador (CST)', region: 'América' },
  { value: 'America/Havana', label: 'La Habana (CST/CDT)', region: 'América' },
  { value: 'America/Santo_Domingo', label: 'Santo Domingo (AST)', region: 'América' },
  { value: 'America/Puerto_Rico', label: 'Puerto Rico (AST)', region: 'América' },
  { value: 'America/Toronto', label: 'Toronto (EST/EDT)', region: 'América' },
  { value: 'America/Vancouver', label: 'Vancouver (PST/PDT)', region: 'América' },
  // Europa
  { value: 'Europe/London', label: 'Londres (GMT/BST)', region: 'Europa' },
  { value: 'Europe/Dublin', label: 'Dublín (GMT/IST)', region: 'Europa' },
  { value: 'Europe/Lisbon', label: 'Lisboa (WET/WEST)', region: 'Europa' },
  { value: 'Europe/Madrid', label: 'Madrid (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Paris', label: 'París (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Berlin', label: 'Berlín (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Rome', label: 'Roma (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Amsterdam', label: 'Ámsterdam (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Brussels', label: 'Bruselas (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Zurich', label: 'Zúrich (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Vienna', label: 'Viena (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Warsaw', label: 'Varsovia (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Prague', label: 'Praga (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Stockholm', label: 'Estocolmo (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Oslo', label: 'Oslo (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Copenhagen', label: 'Copenhague (CET/CEST)', region: 'Europa' },
  { value: 'Europe/Helsinki', label: 'Helsinki (EET/EEST)', region: 'Europa' },
  { value: 'Europe/Athens', label: 'Atenas (EET/EEST)', region: 'Europa' },
  { value: 'Europe/Bucharest', label: 'Bucarest (EET/EEST)', region: 'Europa' },
  { value: 'Europe/Kiev', label: 'Kiev (EET/EEST)', region: 'Europa' },
  { value: 'Europe/Minsk', label: 'Minsk (FET)', region: 'Europa' },
  { value: 'Europe/Moscow', label: 'Moscú (MSK)', region: 'Europa' },
  { value: 'Europe/Istanbul', label: 'Estambul (TRT)', region: 'Europa' },
  // Asia
  { value: 'Asia/Dubai', label: 'Dubái (GST)', region: 'Asia' },
  { value: 'Asia/Riyadh', label: 'Riad (AST)', region: 'Asia' },
  { value: 'Asia/Tehran', label: 'Teherán (IRST/IRDT)', region: 'Asia' },
  { value: 'Asia/Kabul', label: 'Kabul (AFT)', region: 'Asia' },
  { value: 'Asia/Karachi', label: 'Karachi (PKT)', region: 'Asia' },
  { value: 'Asia/Kolkata', label: 'Kolkata (IST)', region: 'Asia' },
  { value: 'Asia/Kathmandu', label: 'Katmandú (NPT)', region: 'Asia' },
  { value: 'Asia/Dhaka', label: 'Daca (BST)', region: 'Asia' },
  { value: 'Asia/Rangoon', label: 'Rangún (MMT)', region: 'Asia' },
  { value: 'Asia/Bangkok', label: 'Bangkok (ICT)', region: 'Asia' },
  { value: 'Asia/Jakarta', label: 'Yakarta (WIB)', region: 'Asia' },
  { value: 'Asia/Singapore', label: 'Singapur (SGT)', region: 'Asia' },
  { value: 'Asia/Kuala_Lumpur', label: 'Kuala Lumpur (MYT)', region: 'Asia' },
  { value: 'Asia/Manila', label: 'Manila (PHT)', region: 'Asia' },
  { value: 'Asia/Shanghai', label: 'Shanghái (CST)', region: 'Asia' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)', region: 'Asia' },
  { value: 'Asia/Taipei', label: 'Taipéi (CST)', region: 'Asia' },
  { value: 'Asia/Tokyo', label: 'Tokio (JST)', region: 'Asia' },
  { value: 'Asia/Seoul', label: 'Seúl (KST)', region: 'Asia' },
  // África
  { value: 'Africa/Cairo', label: 'El Cairo (EET/EEST)', region: 'África' },
  { value: 'Africa/Johannesburg', label: 'Johannesburgo (SAST)', region: 'África' },
  { value: 'Africa/Lagos', label: 'Lagos (WAT)', region: 'África' },
  { value: 'Africa/Nairobi', label: 'Nairobi (EAT)', region: 'África' },
  { value: 'Africa/Casablanca', label: 'Casablanca (WET/WEST)', region: 'África' },
  // Oceanía
  { value: 'Australia/Sydney', label: 'Sídney (AEST/AEDT)', region: 'Oceanía' },
  { value: 'Australia/Melbourne', label: 'Melbourne (AEST/AEDT)', region: 'Oceanía' },
  { value: 'Australia/Brisbane', label: 'Brisbane (AEST)', region: 'Oceanía' },
  { value: 'Australia/Perth', label: 'Perth (AWST)', region: 'Oceanía' },
  { value: 'Pacific/Auckland', label: 'Auckland (NZST/NZDT)', region: 'Oceanía' },
  { value: 'Pacific/Fiji', label: 'Fiyi (FJT/FJST)', region: 'Oceanía' },
  // UTC
  { value: 'UTC', label: 'UTC (Tiempo Universal)', region: 'UTC' },
];

export const TIMEZONE_SELECT_OPTIONS = TIMEZONES.map((tz) => ({
  value: tz.value,
  label: `${tz.label}`,
}));

export function getTimezoneLabel(value: string): string {
  return TIMEZONES.find((tz) => tz.value === value)?.label ?? value;
}
